// List of all user roles except parent
export const ROLES = [
  { key: 'therapist', label: 'Therapist' },
  { key: 'shadow_teacher', label: 'Shadow Teacher' },
  { key: 'special_educator', label: 'Special Educator' },
  { key: 'psychologist', label: 'Psychologist' },
  { key: 'doctor', label: 'Doctor' },
  { key: 'cdc', label: 'CDC/Center' },
  { key: 'inclusive_school', label: 'Inclusive School' },
  { key: 'mainstream_school', label: 'Mainstream School' },
  { key: 'corporate', label: 'Corporate' }
];
